module.exports = __webpack_public_path__ + "img/antes_despues_38.7388a802.png";